
































import { groupBy } from 'lodash'
import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import Icon from '../../Icon/Icon.vue'
import { XTR_CURRENCY } from "../../Shop/CashRegisters/constants";
import { getShopPriorityList } from '../logic/helpers'
import { Getaway, GlobalSubType, SelectedShop, Shop } from '../logic/types'

@Component({
  components: { Icon }
})
export default class CurrencySelect extends Vue {
  @Prop() readonly shops!: { [key in Shop]: Array<Getaway> }

  @VModel({ type: Object }) selectedShop!: SelectedShop | null

  get shopButtons():any {
    let orderedButtons: { [key in Shop]?: Array<Getaway> } = {}

    for (const shop of getShopPriorityList()) {
      if (shop !== 'global') {
        if (this.shops[shop] && this.shops[shop].length) {
          orderedButtons[shop] = this.shops[shop]
        }
      } else {
        Object.assign(orderedButtons, groupBy(this.shops[shop], 'currency_short_name'))
      }
    }

    return orderedButtons
  }

  materialIcon(group: 'llc' | 'bonus') {
    if (group === 'bonus') {
      return 'card_giftcard'
    }

    if (group === 'llc') {
      return 'corporate_fare'
    }
  }

  // eslint-disable-next-line consistent-return
  getIcon(shop: Shop): string | undefined {
    if (shop === Shop.Local) {
      return '₽'
    }

    if (shop === Shop.Crypto) {
      return '₿'
    }
  }

  // eslint-disable-next-line consistent-return
  getCurrencyAlias(shop: Shop): string | undefined {
    if (shop === Shop.Local) {
      return 'RUB'
    }

    if (shop === Shop.Crypto) {
      return 'Crypto currency'
    }

    if (shop === Shop.Llc) {
      return 'LLC'
    }

    if (shop === Shop.Bonus) {
      return 'Bonus'
    }
  }

  globalSubTypeIcon(currencyAlias: GlobalSubType | string) {
    if (currencyAlias === XTR_CURRENCY) {
      return '★'
    }

    return currencyAlias
  }

  globalSubTypeAlias(currencyAlias: GlobalSubType | string) {
    if (currencyAlias === XTR_CURRENCY) {
      return 'Telegram Stars'
    }

    return currencyAlias
  }
}
